import { FC, ReactElement, SyntheticEvent } from 'react';

// Components
import Typography from 'Components/ds/Typography';
import MapleAccordion from 'Components/ds/MapleAccordion';
import MapleAccordionSummary from 'Components/ds/MapleAccordionSummary';
import MapleAccordionDetails from 'Components/ds/MapleAccordionDetails';

interface QuestionParams {
  expanded: boolean;
  question: string;
  answer: string | ReactElement;
  onChange: (event: SyntheticEvent<Element, Event>, expanded: boolean) => void;
}

const Question: FC<QuestionParams> = ({ expanded, question, answer, onChange }): ReactElement => {
  return (
    <MapleAccordion expanded={expanded} onChange={onChange}>
      <MapleAccordionSummary>
        <Typography variant='h5' weight='bold' color='ds.neutral.900'>
          {question}
        </Typography>
      </MapleAccordionSummary>
      <MapleAccordionDetails>
        {typeof answer === 'string' ? (
          <Typography variant='paragraphSmall' color='ds.neutral.400'>
            {answer}
          </Typography>
        ) : (
          <>{answer}</>
        )}
      </MapleAccordionDetails>
    </MapleAccordion>
  );
};

export default Question;
